import { render } from "./searchall.vue?vue&type=template&id=9952819c&scoped=true"
import script from "./searchall.vue?vue&type=script&lang=js"
export * from "./searchall.vue?vue&type=script&lang=js"

import "./searchall.vue?vue&type=style&index=0&id=9952819c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9952819c"]])

export default __exports__